<template>
	<el-dialog append-to-body :title="title" :visible.sync="dialogVisible" @close="$emit('update:visible',false)">
		<div class="view">
			<!-- <div class="title">
			<i class="goback el-icon-arrow-left" @click="goback"></i>
			模板列表
		</div> -->
			<div class="content">
				<!--      <div class="notice">-->
				<!--        <p>-->
				<!--          <i class="el-alert__icon el-icon-warning"></i>商城功能未开启，如需在小程序展示商城，请先在“商城设置”中启用商城功能-->
				<!--        </p>-->
				<!--      </div>-->

				<div class="condition">

					<div class="other_wrap">
						<!-- <el-button type="primary" @click="addgoods" size="small">添加</el-button> -->
						<el-button type="primary" @click="addspecification" size="small">新增</el-button>
					</div>
				</div>
				<div class="table_wrap">
					<el-table :data="tableData" style="width: 100%" @selection-change="handleSelectionChange">
						<el-table-column type="selection" width="55"></el-table-column>
						<el-table-column label="背景图" align="center">
							<template slot-scope="scope">
								<div class="td_img">
									<img :src="scope.row.background" alt />
								</div>
							</template>
						</el-table-column>
						<el-table-column prop="pics" label="效果图" align="center">
							<template slot-scope="scope">
								<img :src="scope.row.pics" alt="">
							</template>
						</el-table-column>

						<el-table-column prop="updated_time" label="更新时间" align="center"></el-table-column>
						<el-table-column prop="created_time" label="创建时间" align="center"></el-table-column>

						<el-table-column prop="order_sort" label="排序" align="center">
							<template slot-scope="scope">
								<el-input type="text" v-model="scope.row.order_sort" @blur="bindInputBlur"></el-input>
							</template>
						</el-table-column>
						<el-table-column label="操作" width="180" align="center" fixed="right">
							<template slot-scope="scope">
								<el-button @click="edit(scope.row.id)" type="text" size="small">编辑</el-button>
								<!-- <el-button @click="copy(scope.row.id)" type="text" size="small">复制</el-button> -->
								<el-button @click="del(scope.row.id)" type="text" size="small">删除</el-button>
								<i v-if="scope.row.is_sale===0" class="el-icon-upload2 shelf_icon"
									@click="putonshelves(scope.row.id)"></i>
								<i v-if="scope.row.is_sale===1" class="el-icon-download shelf_icon"
									@click="pulloffshelves(scope.row.id)"></i>
							</template>
						</el-table-column>
					</el-table>
					<div class="table_oper">
						<!-- @click="batchaddtype">批量重新生成效果图 -->
						<el-button :disabled="this.multipleSelection&&this.multipleSelection.length=== 0"
							@click="batchadDelete">批量删除
						</el-button>
					</div>
					<div class="pag_wrap">
						<el-pagination background @current-change="pageIndexChange" :page-size="page.pagesize"
							:current-page="page.pageindex" layout="total, prev, pager, next"
							:total="page.total"></el-pagination>
					</div>
				</div>
			</div>
			<chooseClassifyDialog :ids="ids" :type="type" flag="goods" :visible.sync="chooseclassifydialog"
				v-if="chooseclassifydialog" @success="success"></chooseClassifyDialog>
			<revisionCommissionDialog :ids="ids" :visible.sync="revisioncommissiondialog"
				v-if="revisioncommissiondialog" @success="success"></revisionCommissionDialog>
			<modifiyFreightDialog :ids="ids" :visible.sync="modifiyfreightdialog" v-if="modifiyfreightdialog"
				:logisticsnum="logisticsnum" @success="success"></modifiyFreightDialog>

			<goodsCustomTemplateDialog :ids="ids" visible.sync="true" @success="success" :templateId="templateId"
				:templateDetailId="templateDetailId" :templateType="templateType">
			</goodsCustomTemplateDialog>
			<goodsCustomTestDialog visible="true">
			</goodsCustomTestDialog>
			<goodsCustomTemplateNewDialog :id="id" :visible.sync="specificationdialog" v-if="specificationdialog"
				@specificationsuccess="specificationsuccess" :templateId="templateId"
				:templateDetailId="templateDetailId" :templateType="templateType"></goodsCustomTemplateNewDialog>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button @click="dialogVisible = false">取 消</el-button>
			<el-button type="primary" @click="save('form')">确 定</el-button>
		</span>
	</el-dialog>
</template>
<script>
	import goodsCustomTemplateNewDialog from "@/components/dialog/goodsCustomTemplateNewDialog.vue";
	import api from "@/api.js";
	import {
		pagination,
		checktype,
		getlabelbykey,
		goodtype,
		goodstype
	} from "@/util/util.js";
	import chooseClassifyDialog from "@/components/dialog/chooseClassifyDialog.vue";
	import revisionCommissionDialog from "@/components/dialog/revisionCommissionDialog.vue";
	import modifiyFreightDialog from "@/components/dialog/modifiyFreightDialog.vue";
	import goodsCustomTemplateDialog from '@/components/dialog/goodsCustomTemplateDialog.vue';
	import goodsCustomTestDialog from '@/components/dialog/goodsCustomTestDialog.vue';
	export default {
		name: "goodsSelectSpecificationDialog",
		props: ["visible", "id", "customMakeId"],
		components: {
			goodsCustomTemplateNewDialog,
			chooseClassifyDialog,
			revisionCommissionDialog,
			modifiyFreightDialog,
			goodsCustomTemplateDialog,
			goodsCustomTestDialog
		},
		watch: {
			visible() {
				this.dialogVisible = this.visible;
			},
			customMakeId(value) {

			}
		},
		data() {
			return {
				customTemplateShow: true,
				dialogVisible: this.visible,
				title: "定制规格",
				formdata: {
					name: ""
				},
				tableData: [],
				del_spec: [],
				del_item: [],
				lock: true,
				rules: {
					name: [{
						required: true,
						message: "请输入类目名称",
						trigger: "blur"
					}]
				},
				page: {
					pageindex: pagination.pageIndex,
					pagesize: pagination.pageSize,
					total: pagination.total
				},
				specificationdialog: false,
				currentRow: '',
				defaultprops: {
					value: "id",
					label: "name",
					children: "child"
				},

				checktype: checktype,
				goodsId: 0,
				multipleSelection: [],
				options: [],
				cateoptions: [],
				ids: "",
				type: "",
				chooseclassifydialog: false,
				revisioncommissiondialog: false,
				modifiyfreightdialog: false,
				logisticsnum: "",
				templateType: '',
				templateDetailId: '',
				templateId: '',
				customTestShow: ''
			};
		},
		created() {
			// if (this.id) {
			//   this.title = "编辑类目";
			//   this.queryspecification();
			// }
			this.goodsId = this.customMakeId;
			this.init();

		},
		methods: {
			specificationsuccess() {

			},
			// 添加类目
			addspecification() {
				this.id = "";
				this.templateDetailId = ''
				this.templateId = this.goodsId
				this.specificationdialog = true;
			},
			bindInputBlur(e) {
				console.log(e, 'e')
				return
				let params = {
					page: this.page.pageindex,
					id: this.goodsId
				};
				this.axios
					.post(api.make_goods_images_save, params)
					.then(response => {
						if (response.data.code == 0) {
							this.tableData = response.data.list;
							this.page.total = response.data.all_page;
						} else {
							this.page.total = 0;
						}
					})
					.catch(response => {});
			},
			// 查询分类
			querycatelist() {
				let params = {};
				this.axios
					.post(api.goods_goods_cate_list, params)
					.then(response => {
						if (response.data.code == 0) {
							this.cateoptions = this.translatecate(response.data.list || []);
						} else {}
					})
					.catch(response => {});
			},
			// 转换分类数据
			translatecate(data) {
				if (data && data.length) {
					data.forEach(item => {
						if (item.child && item.child.length) {
							item.child = this.translatecate(item.child);
						} else {
							item.child = null;
						}
					});
				}
				return data;
			},
			//初始化请求
			init() {
				this.page.pageindex = 1;
				this.querylist();
			},
			//查询列表
			querylist() {
				let params = {
					page: this.page.pageindex,
					typeId: this.goodsId
				};
				this.axios
					.post(api.make_goods_images, params)
					.then(response => {
						if (response.data.code == 0) {
							this.tableData = response.data.list;
							this.page.total = response.data.all_page;
						} else {
							this.page.total = 0;
						}
					})
					.catch(response => {});
			},
			// 分页
			pageIndexChange(pageindex) {
				this.page.pageindex = pageindex;
				this.querylist();
			},
			gettypelabel(type) {
				return getlabelbykey(goodtype, type);
			},
			// 切换状态
			changetype() {
				this.page.pageindex = 1;
				this.querylist();
			},
			// 选择表格行
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			goback() {
				this.$router.go(-1);
			},
			// 添加商品
			addgoods() {
				this.customTestShow = true
				console.log(this.customTestShow, 'this.customTestShow')
				return
				this.templateType = 'add'
				this.templateDetailId = ''
				this.templateId = this.goodsId
				this.customTemplateShow = true
				console.log(this.customTemplateShow, 'this.customTemplateShow')

			},
			// 编辑
			edit(id, type) {
				// let query = {
				// 	id:this.goodsId,
				// 	detailId: id,
				// 	type: 'edit'
				// }

				this.templateType = 'edit'
				this.templateDetailId = id
				this.templateId = this.goodsId
				// this.customTemplateShow = true
				this.specificationdialog = true;

				console.log(this.customTemplateShow, 'this.customTemplateShow')

			},
			// 复制商品
			copy(id) {
				this.$confirm('将为您复制该商品?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.axios
						.post(api.goods_copy, {
							goods_id: id
						})
						.then(response => {
							if (response.data.code == 0) {
								this.$message.success("商品复制成功");
								this.querylist();
							}
						})
						.catch(response => {});
				}).catch(() => {

				});
			},
			del(id) {
				this.$confirm("是否删除?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning"
					})
					.then(() => {
						this.sumbitDel(id);
					})
					.catch(() => {
						this.$message({
							type: "warning",
							message: "已取消删除"
						});
					});
			},
			// 删除
			sumbitDel(id) {
				let params = {
					id: id
				};
				this.axios
					.post(api.custom_del, params)
					.then(response => {
						if (response.data.code == 0) {
							this.querylist();
							this.$message({
								message: "删除成功",
								type: "success"
							});
						} else {}
					})
					.catch(response => {});
			},
			// 获取选择的id
			getcheckids() {
				let ids = [];
				if (this.multipleSelection && this.multipleSelection.length > 0) {
					this.multipleSelection.forEach(item => {
						ids.push(item.id);
					});
				}
				return ids.join(",");
			},

			// 批量添加到分类
			batchaddtype() {
				this.ids = this.getcheckids();
				this.type = "A";
				this.chooseclassifydialog = true;
			},
			// 批量添加到分类
			batchadDelete() {
				let that = this
				this.ids = this.getcheckids();
				console.log(this.ids, 'idsids')
				this.$confirm("是否删除?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning"
					})
					.then(() => {
						that.sumbitDel(this.ids);
					})
					.catch(() => {
						that.$message({
							type: "warning",
							message: "已取消删除"
						});
					});
			},
			// 批量操作成功回调
			success() {
				this.querylist();
			},

			// 上架
			putonshelves(id) {
				let params = {
					id: [id]
				};
				this.axios
					.post(api.goods_up_shelf, params)
					.then(response => {
						if (response.data.code == 0) {
							this.querylist();
							this.$message({
								message: "上架成功",
								type: "success"
							});
						} else {}
					})
					.catch(response => {});
			},
			// 批量上架
			batchputonshelves() {
				let params = {
					id: this.getcheckids()
				};
				this.axios
					.post(api.goods_up_shelf, params)
					.then(response => {
						if (response.data.code == 0) {
							this.querylist();
							this.$message({
								message: "批量上架成功",
								type: "success"
							});
						} else {}
					})
					.catch(response => {});
			},
			// 下架
			pulloffshelves(id) {
				let params = {
					id: [id]
				};
				this.axios
					.post(api.goods_down_shelf, params)
					.then(response => {
						if (response.data.code == 0) {
							this.querylist();
							this.$message({
								message: "下架成功",
								type: "success"
							});
						} else {}
					})
					.catch(response => {});
			},
			// 批量下架
			batchpulloffshelves() {
				let params = {
					id: this.getcheckids()
				};
				this.axios
					.post(api.goods_down_shelf, params)
					.then(response => {
						if (response.data.code == 0) {
							this.querylist();
							this.$message({
								message: "批量下架成功",
								type: "success"
							});
						} else {}
					})
					.catch(response => {});
			},
			save(){
				if(this.multipleSelection&&this.multipleSelection.length>0){
					this.$emit('pickCustomList',this.multipleSelection)
					this.dialogVisible = false
				}else{
					this.$message.warning('请先勾选')
					return
				}
			}

		},
	};
</script>

<style scoped>
	.shelf_icon {
		cursor: pointer;
	}
</style>